import React, { useState } from "react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "./ui/dialog";
import { Input } from "./ui/input";
import { Button } from "./ui/button";
import { joinWaitlist } from "../services/api";
import { toast } from "sonner";
import { BellRing, Loader2 } from "lucide-react";

const T = {
  de: {
    title: "Benachrichtigen lassen",
    desc: "Unser Lieferant ist zurzeit ausverkauft. Trag dich ein — wir melden uns persönlich, sobald unsere Weine wieder lieferbar sind.",
    name: "Name",
    email: "E-Mail-Adresse *",
    submit: "Vormerken",
    success: "Danke! Wir melden uns, sobald wieder lieferbar.",
    error: "Das hat leider nicht geklappt — bitte prüfe die E-Mail-Adresse.",
  },
  en: {
    title: "Get notified",
    desc: "Our supplier is currently sold out. Sign up and we'll contact you personally as soon as our wines are available again.",
    name: "Name",
    email: "Email address *",
    submit: "Notify me",
    success: "Thank you! We'll be in touch as soon as we're back in stock.",
    error: "That didn't work — please check your email address.",
  },
};

export const WaitlistDialog = ({ open, onOpenChange, lang = "de" }) => {
  const t = T[lang] || T.de;
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await joinWaitlist({ name, email });
      toast.success(t.success);
      setName("");
      setEmail("");
      onOpenChange(false);
    } catch {
      toast.error(t.error);
    }
    setLoading(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md" data-testid="waitlist-dialog">
        <DialogHeader>
          <DialogTitle className="font-serif text-2xl text-wine flex items-center gap-2"><BellRing className="w-5 h-5 text-gold" /> {t.title}</DialogTitle>
          <DialogDescription>{t.desc}</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-3 mt-2">
          <Input data-testid="waitlist-name-input" placeholder={t.name} value={name} onChange={(e) => setName(e.target.value)} />
          <Input data-testid="waitlist-email-input" type="email" required placeholder={t.email} value={email} onChange={(e) => setEmail(e.target.value)} />
          <Button data-testid="waitlist-submit-button" type="submit" disabled={loading || !email} className="w-full bg-wine hover:bg-wine-dark text-white h-11 rounded-full gap-2">
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <BellRing className="w-4 h-4" />} {t.submit}
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default WaitlistDialog;
